import React from "react";
import Header from "../../components/common/Header";
import Sidebar from "../../components/common/Sidebar";
import Footer from "../../components/common/Footer";
import AddMemberForm from "../../components/members/AddMemberForm";
import { RODEO_PAGE_NAME } from "../../_config";

const EditMemberContainer: React.FC = () => {
  return (
    <>
      <Header variant="topbar" />
      <Sidebar page={RODEO_PAGE_NAME.ADD_MEMBER} showSettingsSidebar={true} />
      <AddMemberForm />
      <Footer variant="dashboard" />
    </>
  );
};

export default EditMemberContainer;
